import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Image} from '@udemy/react-core-components';
import {Modal} from '@udemy/react-dialog-components';

import styles from './personal-plan-banner-modal.module.less';

interface PersonalPlanBannerModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ValueProp = ({headline, text}: {headline: string; text: string}) => {
    return (
        <div className={styles.prop}>
            <div className="ud-heading-lg">{headline}</div>
            <div className="ud-text-lg">{text}</div>
        </div>
    );
};

export const PersonalPlanBannerModal: React.FC<PersonalPlanBannerModalProps> = ({
    isOpen,
    onClose,
}) => {
    const {gettext} = useI18n();

    const personalPlanValueProps = [
        {
            headline: gettext('Fresh and relevant'),
            text: gettext(
                'We add to the collection based on market trends and feedback from learners and their organizations.',
            ),
        },
        {
            headline: gettext('Strength in numbers'),
            text: gettext(
                'We curate the collection based on unique data points to identify new and emerging skills.',
            ),
        },
        {
            headline: gettext('Only getting better'),
            text: gettext(
                'We continuously refine the collection to help learners like you stay one step ahead.',
            ),
        },
    ];

    return (
        <Modal title="" isOpen={isOpen} onClose={onClose} className={styles['banner-modal']}>
            <h1 className="ud-heading-serif-xxl">{gettext('Udemy Personal Plan')}</h1>
            <p className={classNames('ud-text-lg', styles.message)}>
                {gettext(
                    'A collection of top-rated courses to help you level-up at work and in life. Here are the benefits:',
                )}
            </p>
            <Image
                alt=""
                className={styles.prop}
                width={120}
                height={120}
                src="https://s.udemycdn.com/teaching/value-prop-teach-v3.jpg"
                srcSet={`https://s.udemycdn.com/teaching/value-prop-teach-v3.jpg 1x, https://s.udemycdn.com/teaching/value-prop-teach-2x-v3.jpg 2x`}
            />
            {personalPlanValueProps.map((prop, index) => (
                <ValueProp key={index} headline={prop.headline} text={prop.text} />
            ))}
        </Modal>
    );
};
